module.exports = __webpack_public_path__ + "static/img/yuanqu.c0ecc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/yuanqu.png
// module id = pgPc
// module chunks = 1